import styled from '@emotion/styled';

/**
 * z-index must be below overlay layers so the button never overlaps modals/drawers/filter panels.
 * Design system: Modal underlay 3000, Drawer underlay 2000. Keep button < 2000.
 */
const SCROLL_TO_TOP_Z_INDEX = 1500;

export const Container = styled.button<{ isVisible: boolean; isAtBottom: boolean }>`
  position: fixed;
  right: 32px;
  bottom: ${({ isAtBottom }) => (isAtBottom ? '24px' : '40px')};
  z-index: ${SCROLL_TO_TOP_Z_INDEX};
  border: none;
  outline: none;
  border-radius: 12px;
  width: 32px;
  height: 32px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  background-color: ${({ theme }) => theme.colors.secondary.normal};
  color: ${({ theme }) => theme.colors.primary.normal};
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  pointer-events: ${({ isVisible }) => (isVisible ? 'auto' : 'none')};
  transition: opacity 0.25s ease, bottom 0.25s ease, padding 0.25s ease, width 0.25s ease,
    background-color 0.25s ease;
  cursor: pointer;

  span {
    overflow: hidden;
    white-space: nowrap;
    max-width: 0;
    opacity: 0;
    transition: max-width 0.2s ease, opacity 0.2s ease;
  }

  &:hover {
    gap: 8px;
    width: auto;
    max-width: none;
    padding: 8px 16px;
    background-color: ${({ theme }) => theme.colors.secondary.medium};
  }

  &:hover span {
    max-width: 100%;
    opacity: 1;
  }

  &:focus-visible {
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.status.success.light};
  }

  @media (max-width: 768px) {
    right: 16px;
    bottom: ${({ isAtBottom }) => (isAtBottom ? '16px' : '24px')};
  }
`;
